import { render, staticRenderFns } from "./TextDeleteButton.vue?vue&type=template&id=1ee6cf4c&scoped=true"
import script from "./TextDeleteButton.vue?vue&type=script&lang=js"
export * from "./TextDeleteButton.vue?vue&type=script&lang=js"
import style0 from "./TextDeleteButton.vue?vue&type=style&index=0&id=1ee6cf4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee6cf4c",
  null
  
)

export default component.exports